<template>
    <strong class="v-schedule__mainmsg r-strong" v-if="!disabled">
        Выберите время, в которое вы готовы принять пациентов
    </strong>
</template>

<script>
	import {mapState} from 'vuex';

    export default {
		name: 'ScheduleChangeMessage',
        computed: {
			...mapState([
				'disabled',
			]),
        },
    }
</script>

